export default __webpack_public_path__ + "static/media/step-1.63bacbfd.svg";